export enum EAccountSectionQueryKey {
  BONUSES = 'bonuses',
  BONUS = 'bonus',
  BONUS_TYPE = 'bonusType'
}

export const QUERY_KEYS_TO_REMOVE_ON_ACCOUNT_POPUP_CLOSE = [
  EAccountSectionQueryKey.BONUSES,
  EAccountSectionQueryKey.BONUS,
  EAccountSectionQueryKey.BONUS_TYPE
];
